export const PUBLISHING_APPROVAL_MODE = {
  OFF: 'off',
  PER_TRAINING: 'per_training',
  MANDATORY_COMPANY_WIDE: 'mandatory_company_wide',
} as const;

export type PublishingApprovalMode =
  (typeof PUBLISHING_APPROVAL_MODE)[keyof typeof PUBLISHING_APPROVAL_MODE];

// Reviewer role flags configurable per training (Page 3).
export const PUBLISHING_APPROVAL_ROLE = {
  ADMIN: 'admin',
  GLOBAL_COACH: 'global_coach',
  AUTHOR: 'author',
  EDITORS: 'editors',
} as const;

export type PublishingApprovalRole =
  (typeof PUBLISHING_APPROVAL_ROLE)[keyof typeof PUBLISHING_APPROVAL_ROLE];

export const PUBLISHING_APPROVAL_ACTION = {
  APPROVE: 'approve',
  DECLINE: 'decline',
} as const;

export type PublishingApprovalAction =
  (typeof PUBLISHING_APPROVAL_ACTION)[keyof typeof PUBLISHING_APPROVAL_ACTION];
